import type { ReactNode } from 'react'

import { Logo } from '@/components/layout/logo.atom'

export const AuthMobileLogoBar: React.FC = (): ReactNode => (
  <div className="auth-mobile-logo-bar bg-saaga-primary-700 px-6 py-4 lg:hidden">
    <Logo className="h-7 w-auto brightness-0 invert" />
  </div>
)
